export const showLocalNotification = (title: string, message: string, onPress: () => void) => {
  const notification = new Notification(title, {
    body: message,
  });

  notification.onclick = () => {
    onPress();
  };
};

export const getLocalNotificationsPermission = () => {
  try {
    Notification.requestPermission();
  } catch (e) {}
};
